import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NavPanel from '../../../Components/NavPanel/NavPanel';
import Pagination from '../../../Components/Pagination/Pagination';
import EventCard from '../EventCard/EventCard';
import classes from './EventsGeneral.module.scss';
import { GeneralContext } from '../../../context/generalContext';
import { getData } from '../../../utils/utils';
import { getBaseUrl } from '../../../functions/getBaseUrl';
import { eventsAPI } from '../../../services/GeneralService';
import SkeletonArticles from '../../../Components/Skeleton/SkeletonArticles/SkeletonArticles';

export default function EventsGeneral() {
  const { windowWidth, activeLanguage } = useContext(GeneralContext);

  const location = useLocation();
  const [curPageData, setCurPageData] = useState(null);

  const [currentPage, setCurrentPage] = useState(1 || curPageData);
  const [eventsPerPage, setEventsPerPage] = useState(9);
  const [activePage, setActivePage] = useState(1); // для реализации ф-ции "показать еще со сменой выделенной страницы в навигации"

  useEffect(() => {
    if (location && (location.pathname === '/events' || location.pathname === '/en/events') && location.search !== '') {
      setCurrentPage(parseInt(location.search.match(/\d+/)));
      setActivePage(parseInt(location.search.match(/\d+/)));
    } else if (
      location &&
      (location.pathname === '/events' || location.pathname === '/en/events') &&
      location.search === ''
    ) {
      setCurrentPage(1);
      setActivePage(1);
    }
  }, []);

  const { data, isLoading } = eventsAPI.useFetchAllEventsQuery({ currentPage, eventsPerPage });

  useEffect(() => {
    windowWidth >= 617 && windowWidth <= 1200 ? setEventsPerPage(8) : setEventsPerPage(9);
  }, [windowWidth]);

  const paginate = pagenumber => {
    setCurrentPage(pagenumber);
    setActivePage(pagenumber);
  };

  const getNextPage = () => {
    activePage === data.lastPage ? setCurrentPage(data.lastPage) : setCurrentPage(activePage + 1);

    activePage === data.lastPage ? setActivePage(data.lastPage) : setActivePage(activePage + 1);
  };
  const getPrevPage = () => {
    currentPage === 1 ? setCurrentPage(1) : setCurrentPage(prev => prev - 1);
    activePage === 1 ? setActivePage(1) : setActivePage(currentPage - 1);
  };
  const getFirstPage = () => {
    setCurrentPage(1);
    setActivePage(1);
  };
  const getLastPage = () => {
    setCurrentPage(data.lastPage);
    setActivePage(data.lastPage);
  };

  const [loadedDataPages, setLoadedDataPages] = useState([]);

  const handleDownloadNextPage = () => {
    const apiUrl = `${getBaseUrl()}/api/events?page=${activePage + 1}&perPage=${eventsPerPage}`;
    getData(apiUrl, setLoadedDataPages, loadedDataPages, 'events');
    setActivePage(prev => prev + 1);
  };

  useEffect(() => {
    if (data) {
      window.scrollTo(0, 0);
      setCurPageData(data.currentPage);
    }
  }, [data]);

  return (
    <>
      <Helmet>
        <title>{activeLanguage === 1 ? 'События | Brasserie Lambic' : 'Events | Brasserie Lambic'}</title>
      </Helmet>
      <div className='wrapper'>
        <NavPanel
          name={activeLanguage === 1 ? 'События' : 'Events'}
          link={activeLanguage === 1 ? '/events' : '/en/events'}
        />
      </div>
      {isLoading && <SkeletonArticles />}
      {data && (
        <div className='wrapper'>
          {data.total > 0 ? (
            <h1 className={classes.header} id='events'>
              {activeLanguage === 1 ? 'События' : 'Events'}
            </h1>
          ) : (
            <h1 className={classes.header} id='articles'>
              {activeLanguage === 1 ? 'Нет доступных событий' : 'No events available'}
            </h1>
          )}

          <div className={classes.events}>
            {data?.events.map(event => (
              <EventCard key={event.id} item={event} />
            ))}
          </div>
          <div className={classes.events}>
            {loadedDataPages.length !== 0 && loadedDataPages.map(event => <EventCard key={event.id} item={event} />)}
          </div>
          {data.total > eventsPerPage && (
            <>
              <Link to={`${window.location.pathname}?page=${activePage + 1}`}>
                <button
                  className={activePage === data.lastPage ? classes.disabled : classes.moreBtn}
                  onClick={handleDownloadNextPage}
                >
                  {activeLanguage === 1 ? 'Показать ещё' : 'Show more'}
                </button>
              </Link>
              <Pagination
                href={activeLanguage === 1 ? 'events' : 'en/events'}
                setLoadedDataPages={setLoadedDataPages}
                currentPage={data.currentPage}
                activePage={activePage}
                lastPage={data.lastPage}
                postsPerPage={eventsPerPage}
                totalPosts={data.total}
                paginate={paginate}
                getPrevPage={getPrevPage}
                getNextPage={getNextPage}
                getFirstPage={getFirstPage}
                getLastPage={getLastPage}
              />
            </>
          )}
        </div>
      )}
    </>
  );
}
